import React, { createContext, ReactElement, Dispatch, SetStateAction } from 'react';
import { IWithChildren } from '../typings/withChildren';
import { useLocalStorage } from '../hooks/useLocalStorage';

export type IUserAccessContext = [IUserAccess[], Dispatch<SetStateAction<IUserAccess[]>>];

export const UserAccessContext = createContext<IUserAccessContext | null[]>([null, null]);

export const UserAccessProvider = ({ children }: IWithChildren): ReactElement => {
  const [userAccess, setUserAccess] = useLocalStorage('userAccess', {}, true);

  return (
    <UserAccessContext.Provider value={[userAccess, setUserAccess]}>
      {children}
    </UserAccessContext.Provider>
  );
};
